import {
    ASSOCIATE_TO_GPS_OPEN_MODAL,
    ASSOCIATE_TO_GPS_CLOSE_MODAL,
    ASSOCIATE_TO_GPS_REQUEST,
    ASSOCIATE_TO_GPS_RESULT
} from 'Redux/actionTypes';

export const associateToGpsOpenModal = () => ({
    type: ASSOCIATE_TO_GPS_OPEN_MODAL
})

export const associateToGpsCloseModal = () => ({
    type: ASSOCIATE_TO_GPS_CLOSE_MODAL
})

export const associateToGpsRequest = (data) => ({
    type: ASSOCIATE_TO_GPS_REQUEST,
    payload: data
})

export const associateToGpsResult = (result) => ({
    type: ASSOCIATE_TO_GPS_RESULT,
    payload: result
})